import IconWrapper from '../../common/wrapper/IconWrapper';
import classes from './booking-link.module.scss';
import { ReactComponent as CancellationPolicyIcon } from '../../../images/icons/bl-secure-payment-icon.svg';
import VerticalStack from '../../common/wrapper/VerticalStack';
import { AppText, AppTitle } from '../../common/typography/app-text';

function CancellationPolicyInfo() {
    return (
        <div className={classes.cancellationPolicyInfo}>
            <IconWrapper color="#000">
                <CancellationPolicyIcon />
            </IconWrapper>
            <VerticalStack space={6}>
                <AppTitle style={{ fontSize: '13px' }}>Booking and cancellation policy</AppTitle>
                <AppText font='small'>
                    A card on file is required to secure your appointment, but you won't be charged.
                    Late cancellation fees may apply.
                </AppText>
            </VerticalStack>
        </div>
    );
}
export default CancellationPolicyInfo;
